import api from './api';

class TaxService {
  // Tax Configuration Management
  async getAllTaxConfigurations() {
    try {
      const response = await api.get('/tax/configurations');
      return response.data;
    } catch (error) {
      console.error('Error fetching tax configurations:', error);
      throw error;
    }
  }

  async getTaxConfigurationById(taxConfigId) {
    try {
      const response = await api.get(`/tax/configurations/${taxConfigId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching tax configuration:', error);
      throw error;
    }
  }

  async getDefaultTaxConfiguration() {
    try {
      const response = await api.get('/tax/configurations/default');
      return response.data;
    } catch (error) {
      console.error('Error fetching default tax configuration:', error);
      throw error;
    }
  }

  async createTaxConfiguration(taxConfig) {
    try {
      const response = await api.post('/tax/configurations', taxConfig);
      return response.data;
    } catch (error) {
      console.error('Error creating tax configuration:', error);
      throw error;
    }
  }

  async updateTaxConfiguration(taxConfigId, taxConfig) {
    try {
      const response = await api.put(`/tax/configurations/${taxConfigId}`, taxConfig);
      return response.data;
    } catch (error) {
      console.error('Error updating tax configuration:', error);
      throw error;
    }
  }

  async deleteTaxConfiguration(taxConfigId) {
    try {
      await api.delete(`/tax/configurations/${taxConfigId}`);
      return true;
    } catch (error) {
      console.error('Error deleting tax configuration:', error);
      throw error;
    }
  }

  async setDefaultTaxConfiguration(taxConfigId) {
    try {
      const response = await api.post(`/tax/configurations/${taxConfigId}/set-default`);
      return response.data;
    } catch (error) {
      console.error('Error setting default tax configuration:', error);
      throw error;
    }
  }

  // Tax Rule Management
  async getAllTaxRules() {
    try {
      const response = await api.get('/tax/rules');
      return response.data;
    } catch (error) {
      console.error('Error fetching tax rules:', error);
      throw error;
    }
  }

  async getTaxRuleById(taxRuleId) {
    try {
      const response = await api.get(`/tax/rules/${taxRuleId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching tax rule:', error);
      throw error;
    }
  }

  async getTaxRulesByConfigId(taxConfigId) {
    try {
      const response = await api.get(`/tax/rules/config/${taxConfigId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching tax rules by config:', error);
      throw error;
    }
  }

  async createTaxRule(taxRule) {
    try {
      const response = await api.post('/tax/rules', taxRule);
      return response.data;
    } catch (error) {
      console.error('Error creating tax rule:', error);
      throw error;
    }
  }

  async updateTaxRule(taxRuleId, taxRule) {
    try {
      const response = await api.put(`/tax/rules/${taxRuleId}`, taxRule);
      return response.data;
    } catch (error) {
      console.error('Error updating tax rule:', error);
      throw error;
    }
  }

  async deleteTaxRule(taxRuleId) {
    try {
      await api.delete(`/tax/rules/${taxRuleId}`);
      return true;
    } catch (error) {
      console.error('Error deleting tax rule:', error);
      throw error;
    }
  }

  // Tax Application
  async applyTaxesToInvoice(invoiceId) {
    try {
      const response = await api.post(`/tax/apply-invoice/${invoiceId}`);
      return response.data;
    } catch (error) {
      console.error('Error applying taxes to invoice:', error);
      throw error;
    }
  }

  async recalculateInvoiceTaxes(invoiceId) {
    try {
      const response = await api.post(`/tax/recalculate-invoice/${invoiceId}`);
      return response.data;
    } catch (error) {
      console.error('Error recalculating invoice taxes:', error);
      throw error;
    }
  }

  // Tax Calculation (for preview purposes)
  async calculateItemTax(item) {
    try {
      const response = await api.post('/tax/calculate-item', item);
      return response.data;
    } catch (error) {
      console.error('Error calculating item tax:', error);
      throw error;
    }
  }

  async calculateInvoiceTax(invoice) {
    try {
      const response = await api.post('/tax/calculate-invoice', invoice);
      return response.data;
    } catch (error) {
      console.error('Error calculating invoice tax:', error);
      throw error;
    }
  }
}

export default new TaxService();